import { type ApiResponse, newRequest } from "std/api/newRequest";
import type { TApiColetasCidade } from "../pages/coletas_cidade";
import type { ApiRelatorioGetParams } from "../types/ApiRelatorioParams";

export function apiRelColetasCidade({ params }: { params: ApiRelatorioGetParams }): Promise<ApiResponse<TApiColetasCidade>> {
	return newRequest({
		url: "Relatorio/CidadeProdutor",
		type: "get",
		idpk: undefined,
		params,
	});
}
